import {
    VIDFLEET_SHOW_CHANGES_HISTORY_LIST,
    VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE,
    VIDFLEET_SHOW_CHANGES_HISTORY_HIDE
} from 'Redux/actionTypes';

export const showChangesHistoryGetData = (filters) => ({
    type: VIDFLEET_SHOW_CHANGES_HISTORY_LIST,
    payload: { filters }
});

export const showChangesHistoryGetDataResult = (data) => ({
    type: VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE,
    payload: data
});

export const showChangesHistoryHide = () => ({
    type: VIDFLEET_SHOW_CHANGES_HISTORY_HIDE,
    //payload: users
  });